import React, { useState } from "react";
import { Typography, Box, Switch, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface IPlatform {
  name: string;
  logo: string;
  id: string;
}

const Platform = ({
  platform,
  handleOpenAuthModal,
  trainingInProgress,
  productParams,
  isDisable,
}: {
  platform: IPlatform;
  handleOpenAuthModal: (name: string) => void;
  trainingInProgress: boolean;
  productParams: any;
  isDisable: boolean;
}) => {
  const [fetchData, setFetchData] = useState<boolean>(false);
  const navigate = useNavigate();

  const { name, logo, id } = platform;

  const handleChangeSwitch = () => {
    setFetchData((prevState) => !prevState);
  };

  const handleRedirectPlayGroundChat = (prodData: any) => {
    const stateObj = {
      playgroundprodData: prodData,
    };
    navigate(`/playground-chat`, { state: stateObj });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      className="platform-card-container"
    >
      <Box
        display="flex"
        justifyContent="end"
        sx={{
          flex: 1,
        }}
      ></Box>
      <Box
        display="flex"
        justifyContent="center"
        sx={{
          marginBottom: "10px",
          marginTop: "9px",
        }}
      >
        {id !== "kb" && id !== "email" && (
          <img src={logo} alt="platform-logo" />
        )}
        {(id === "kb" || id === "email") && (
          <Box
            sx={{
              "& svg": {
                color: "#2858D3",
                fontSize: "2.5rem",
              },
              display: "flex",
              justifyContent: "center",
            }}
          >
            {logo}
          </Box>
        )}
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          height: "40px",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          {name}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        sx={{
          marginTop: "10px",
        }}
      >
        {trainingInProgress && id === "kb" ? (
          <Button
            variant="text"
            disabled
            onClick={() => handleOpenAuthModal(id)}
          >
            Training In Progress
          </Button>
        ) : (
          <Box
            display="flex"
            flexDirection="row"
            className="feature-config-btn-parent"
          >
            <Button
              className="feature-config-btns"
              variant="text"
              onClick={() => handleOpenAuthModal(id)}
              sx={{
                fontSize: "12px",
              }}
              disabled={isDisable}
            >
              Configure
            </Button>
            {id == "chat" &&
              productParams?.products?.[0]?.chatAgentSettings && (
                <Button
                  className="feature-config-btns"
                  onClick={() => handleRedirectPlayGroundChat(productParams)}
                  variant="text"
                  sx={{
                    fontSize: "12px",
                  }}
                  disabled={isDisable}
                >
                  PLAYGROUND
                </Button>
              )}
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default Platform;
